import { apiCall } from 'src/utils/ApiCall';
import {
  GetControlSummaryDataOutput,
  RecordAttributes,
} from '@amzn/controllershiphub-typescript-client';
import { filterAndCleanRecords } from 'src/components/pages/SummaryPage';
import { CONTROL_APIS, ApiError } from 'src/common/config/ApiConstants';

interface DataResponse {
  records: RecordAttributes[][];
  totalRecords: number;
  distinctValues?: Record<string, string[]>;
}

export const getControlData = async (
  controlId: string,
  filters: Record<string, string[]> = {}
): Promise<DataResponse> => {
  try {
    const queryParams = {
      limit: CONTROL_APIS.BATCH_SIZE.toString(),
      ...(Object.keys(filters).length > 0 && {
        filters: JSON.stringify(filters),
      }),
    };

    let allRecords: RecordAttributes[][] = [];
    let lastKey: string | undefined;
    let distinctValues: Record<string, string[]> | undefined;
    let fetchedRecords = 0;

    do {
      const response = await apiCall<GetControlSummaryDataOutput>({
        endpoint: CONTROL_APIS.ENDPOINTS.DATA(controlId),
        queryParams: lastKey ? { ...queryParams, exclusiveStartKey: lastKey } : queryParams,
      });

      if (response.controlData?.records) {
        const newRecordsCount = response.controlData.records.length;
        allRecords = allRecords.concat(response.controlData.records);
        fetchedRecords += newRecordsCount;
      }

      if (response.distinctValues && !lastKey) {
        distinctValues = response.distinctValues;
      }

      lastKey = response.lastEvaluatedKey;
    } while (lastKey);

    const cleanedRecords = filterAndCleanRecords(allRecords);

    return {
      records: cleanedRecords,
      totalRecords: cleanedRecords.length,
      distinctValues,
    };
  } catch (err: unknown) {
    const error = err as Error;
    if (error instanceof ApiError && error.status === 401) {
      throw new Error(CONTROL_APIS.ERROR_MESSAGES.UNAUTHORIZED);
    }
    throw new Error(CONTROL_APIS.ERROR_MESSAGES.DATA_FETCH_FAILED);
  }
};
